// src/utils/axiosInstance.js
import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL, // Use centralized config
  // NO TIMEOUT - user requested no time limits
  // timeout: 0 means no timeout (wait indefinitely)
  timeout: 0,
});

// 🔑 Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
